/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { SegmentHeadline } from 'components/SegmentHeadline'
import { HeaderStandaloneRC } from 'components/HeaderStandaloneRC'
import { Segment } from 'components/Segment'
import { QandA as QuestionAndAnswer } from 'components/QandA'
import { Box } from 'components/Box'
import { questionsAndAnswers, categoryTitles } from 'components/__data'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import { Link } from '@ta-interaktiv/contentbricks'
// TODO Set the correct article ID here
const ARTICLE_ID = '484907250691'
export function AppComponent() {
  return (
    <div className='index'>
      <Masthead articleId={ARTICLE_ID} />
      <ThemeSwitch />
      <HeaderStandaloneRC updated='Aktualisiert 7. Januar 2021' />

      <div className='ui very fitted vertical segment'>
        <div className='ui text container'>
          <div className='ta text'>
            <p>
              Stellen Sie sich vor, die Schweiz erhält bis im Sommer mehrere
              Millionen Dosen mit Impfstoff gegen das Coronavirus. Und dann...
              bleibt sie darauf sitzen. Ein durchaus realistisches Szenario,
              denn die Skepsis im Land ist gross. Dies, obwohl die Impfungen
              hochwirksam, freiwillig und kostenlos sind und bisher nur geringe
              Nebenwirkungen festgestellt wurden.
            </p>
            <p>
              Auf die Frage, warum sie sich nicht gegen Corona impfen lassen
              wollen, meldeten sich in den letzten Tagen Dutzende Leserinnen und
              Leser. Eine Auswahl ihrer Argumente haben wir Claire-Anne Siegrist
              vorgelegt.
            </p>

            <p>
              <img src={require('images/siegrist_big.jpg')} /> Siegrist ist
              Professorin für Vakzinologie an der Universität Genf. Die
              Schweizerin berät die WHO in Impffragen, leitete unter anderem
              auch eine Studie zur Entwicklung des Ebola-Impfstoffs. Von 2004
              bis 2014 präsidierte Siegrist die Eidgenössische Kommission für
              Impffragen.
            </p>
          </div>
        </div>
      </div>

      <div className='ui vertical very fitted  segment'>
        {questionsAndAnswers.map((cat, i) => {
          return (
            <React.Fragment key={i + 'main'}>
              <Segment coloured={false} key={i + 'segment'}>
                <>
                  <SegmentHeadline>{categoryTitles[cat[0]]}</SegmentHeadline>
                  {cat[1].map((qa, j) => (
                    <QuestionAndAnswer data={qa} key={i + j + 'question'} />
                  ))}
                </>
              </Segment>
              {i === 0 && (
                <>
                  <Box backgroundColor='#f8f7f4'>
                    <>
                      <h4 style={{ color: '#575247' }}>
                        Zur Impfskepsis in der Schweiz
                      </h4>
                      <p style={{ color: '#575247' }}>
                        Ein grosser Teil der Schweizer Bevölkerung steht der
                        Corona-Impfung skeptisch gegenüber. So zeigte eine{' '}
                        <Link allowWordWrap href='669813285188'>
                          repräsentative Tamedia-Umfrage
                        </Link>{' '}
                        von Ende November, dass sich 42 Prozent der
                        Schweizerinnen und Schweizer nicht oder eher nicht gegen
                        Corona impfen lassen wollen. Politisch gesehen ist die
                        Impfskepsis unter den Anhängern der SVP am grössten: 53
                        Prozent der SVP-Anhänger wollen sich nicht oder eher
                        nicht impfen lassen. Leicht überdurchschnittlich die
                        Skepsis aber auch bei den Grünen: Von ihnen wollen sich
                        45 Prozent nicht oder eher nicht impfen lassen. Eine
                        ebenfalls im November veröffentlichte, genauso
                        repräsentative Umfrage des Bundesamts für Gesundheit kam
                        überdies zum überraschenden Befund, dass die
                        Bereitschaft der Schweizerinnen und Schweizer, sich
                        gegen das Coronavirus zu impfen, zwischen März und
                        Oktober 2020 um zehn Prozent gesunken ist.
                      </p>
                    </>
                  </Box>
                </>
              )}
              {i === 2 && (
                <>
                  <Box backgroundColor='#f8f7f4'>
                    <>
                      <h4 style={{ color: '#575247' }}>Zu den Impfstoffen</h4>
                      <p style={{ color: '#575247' }}>
                        Bis Ende Monat sollten alle Kantone mit Impfungen gegen
                        das Coronavirus begonnen haben. Basel hat am 28.
                        Dezember damit begonnen, Zürich am 4. Januar, die ersten
                        Bernerinnen und Berner werden am 11. Januar geimpft. Die
                        Schweiz hat Impfstoffe der Firmen Astra-Zeneca, Moderna
                        und Pfizer/Biontech bestellt. Letzterer ist als bisher
                        einziger im Einsatz, die Heilmittelbehörde Swissmedic
                        hat ihn im Dezember zugelassen. Das Biontech-Vakzin
                        setzt auf die neuartige mRNA-Technologie. Der Impfstoff
                        von Biontech bietet einen 95-prozentigen Schutz für die
                        Geimpften. Der Bund hat 3 Millionen Impfdosen davon
                        bestellt. Vom Stoff von Astra-Zeneca hat die Schweiz
                        rund 5, vom Stoff von Moderna gut 4.5 Millionen Dosen
                        geordert. Diese beiden Impfstoffe dürften in der Schweiz
                        bald zugelassen werden. Der Moderna-Impfstoff, der in
                        den USA bereits gespritzt wird, basiert ebenfalls auf
                        der mRNA-Technologie und bietet einen gleich guten
                        Schutz wie jener von Biontech. Beim Impfstoff von
                        Astra-Zeneca wird die Immunabwehr über ein modifiziertes
                        Schimpansen-Schnupfenvirus aktiviert. Dieses Vakzin
                        lässt sich leichter lagern als die beiden anderen
                        Stoffe, schützt jedoch nur mit 70-prozentiger
                        Wahrscheinlichkeit vor einer Covid-Erkrankung. In
                        Grossbritannien ist es seit Anfang Jahr im Einsatz.
                      </p>
                    </>
                  </Box>
                </>
              )}
            </React.Fragment>
          )
        })}
      </div>
      <Footer
        articleId={ARTICLE_ID}
        credits={[
          [
            'Zur Umfrage',
            'Dieser Artikel ist das Ergebnis eines Leserinnen- und Leseraufrufs, der Mitte Dezember auf den Websites der Bezahlmedien von Tamedia veröffentlicht wurde. Die Vor- und Nachnamen wurden geändert. Die übrigen Angaben – Alter, Beruf und Wohnkanton – entsprechen den realen Personalien. Bei der Auswahl der Beiträge wurde darauf geachtet, unterschiedliche Altersgruppen, Wohnorte und soziale Milieus zu berücksichtigen.'
          ],
          ['Text', 'Linus Schöpfer'],
          ['Umsetzung', 'Sebastian Broschinski']
        ]}
      />
    </div>
  )
}
